import './Snapshots.css';
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { connect } from 'react-redux';
import config from '@config';

import { isSnapshotView } from '@selectors/location';

import Metas from '@views/Metas';
import PageMenu from '@views/PageMenu';
import Bracket from '@layout/BracketLayout';
import Groups from '@views/Groups';

import Link from 'redux-first-router-link';

export const Snapshots = ({ _id, username, score, snapshotMode }) => (
  <div
    className={[
      'mundial-ideal',
      snapshotMode ? 'snapshot-mode' : 'Snapshots',
    ].join(' ')}
  >
    <Metas
      title={`El pronóstico de ${username} en el Prode Mundial 2026`}
      description="El juego de Página|12 para predecir los resultados del Mundial de Fútbol 2026"
    />

    <div className="hero-bg">
      <div className="hero-content">
        <h2>Prode Ideal de {username}</h2>
        {username && (
          <p className="Snapshots-header">
            Al momento <b>{username}</b> obtuvo <b>{score}</b> puntos{' '}
            <Link to={['reglas']}>¿Cómo se compone este puntaje?</Link>
          </p>
        )}
      </div>
    </div>
    <div className="snapshots-container">
      <Groups />
      <Bracket />
    </div>
  </div>
);

Snapshots.displayName = 'Snapshots';
Snapshots.propTypes = {
  _id: PropTypes.string,
  username: PropTypes.string,
  score: PropTypes.number,
  snapshotMode: PropTypes.bool,
};
Snapshots.defaultProps = {
  _id: '',
  username: '',
  score: 0,
  snapshotMode: false,
};

export const mapStateToProps = (state) => ({
  ...get(state, 'forecastUser'),
  snapshotMode: isSnapshotView(state),
});

export default connect(mapStateToProps)(Snapshots);
